<template>
    <svg
        class="triangle-svg"
        width="200"
        height="200"
        viewBox="0 0 66 17"
        fill="none"
        style="filter: drop-shadow(rgba(0, 0, 0, 0.1) 2px 5px 2px)"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M0 0L0 0.00502248C31.9915 0.219447 58.6646 7.27657 66 16.7387V0H0Z" :fill="color || '#FBFBFB'"></path>
    </svg>
</template>

<script>
export default {
    name: "Triangle",
    props: ["color"],
};
</script>
